import styled from '@emotion/styled'
import { ExtranetContainer, MediaQuery } from '@pharmac-extranet/shared'
import { PharmacH1, PharmacH4, PharmacIcon, PharmacMainLogoMono } from '@pharmac/ui'

const ViewRoot = styled(ExtranetContainer)`
  background: linear-gradient(130.84deg, rgba(136, 40, 143, 0.83) 65.47%, #66d0d5 99.95%);

  height: 100%;
  position: relative;

  ${MediaQuery.maxTablet} {
    width: 100%;
    padding: 0 var(--spacing-large);
  }
`

const LogoContainer = styled.div`
  position: absolute;
  bottom: 50px;
  right: 50px;
`

export const MaintenanceBreakView = () => {
  return (
    <ViewRoot
      full
      flexColumn
      alignCenter
      justifyCenter
    >
      <ExtranetContainer
        paddingMedium
        style={{ border: '5px solid var(--color-accent-1)', borderRadius: '50px' }}
      >
        <PharmacIcon
          stroke="var(--color-accent-1)"
          icon="tool"
          size="50px"
        />
      </ExtranetContainer>
      <PharmacH1
        marginLargeTop
        color="white"
      >
        Palaamme pian!
      </PharmacH1>
      <PharmacH4
        paddingMediumTop
        marginMediumTop
        color="white"
      >
        Päivitämme Portaalia, kokeilethan uudelleen hetken kuluttua.
      </PharmacH4>
      <LogoContainer>
        <PharmacMainLogoMono
          width="250px"
          color="white"
        />
      </LogoContainer>
    </ViewRoot>
  )
}
